export interface IErrorItem {
    field: string,
    desc: string,
    show: boolean
}